import React from "react";
import "./Accueil.css";

const Accueil = () => {
  return (
    <section className="hero">
      <div className="hero-overlay">
        <div className="hero-content">
          <h1>
            {/* Les Tontons Friteurs<br /> */}
            La frite selon Mélanie: <br />
            <span>croustillante, généreuse</span> <br />
            et toujours dans l’ambiance !
          </h1>
          <button className="cta-btn"><a href="/#contacts" className="nav-link">Réservez-nous pour votre événement</a></button>
        </div>
      </div>
    </section>
  );
};

export default Accueil;
